import { render, staticRenderFns } from "./VipCenter.vue?vue&type=template&id=bf000fe4&scoped=true"
import script from "./VipCenter.vue?vue&type=script&lang=js"
export * from "./VipCenter.vue?vue&type=script&lang=js"
import style0 from "./VipCenter.vue?vue&type=style&index=0&id=bf000fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf000fe4",
  null
  
)

export default component.exports